import {
    IDataArray,
    DataArray
} from './../../shared/index';


export class FMILanguage implements IDataArray {
    public Id = 0;
    public Name: string;
    public Description: string;
    public PM_Code: string;
    public PM_Description: string;
    public Active: boolean;

    public GetById(): number {
        return this.Id;
    }
}
